import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import orderService from '../services/orderService';
import toast from 'react-hot-toast';
import {
  HiOutlineTruck,
  HiOutlineCheckCircle,
  HiOutlineRefresh,
} from 'react-icons/hi';
import './Dispatch.css';

const STATUS_LABELS = {
  prepared: 'Lista para despacho',
  in_delivery: 'En camino',
  delivered: 'Entregada',
};

const STATUS_COLORS = {
  prepared: '#06b6d4',
  in_delivery: '#f97316',
  delivered: '#22c55e',
};

const Dispatch = () => {
  const { hasRole } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('prepared');
  const [actionLoading, setActionLoading] = useState(null);

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const [prep, inDel, deliv] = await Promise.all([
        orderService.getAll({ status: 'prepared' }),
        orderService.getAll({ status: 'in_delivery' }),
        orderService.getAll({ status: 'delivered' }),
      ]);
      setOrders([
        ...(prep.data || []),
        ...(inDel.data || []),
        ...(deliv.data || []),
      ]);
    } catch {
      toast.error('Error cargando despacho');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchOrders(); }, []);

  const filteredOrders = orders.filter((o) => o.status === tab);

  const handleAction = async (orderId, action, successMsg) => {
    setActionLoading(orderId);
    try {
      await action(orderId);
      toast.success(successMsg);
      fetchOrders();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Error');
    } finally {
      setActionLoading(null);
    }
  };

  const counts = {
    prepared: orders.filter((o) => o.status === 'prepared').length,
    in_delivery: orders.filter((o) => o.status === 'in_delivery').length,
    delivered: orders.filter((o) => o.status === 'delivered').length,
  };

  return (
    <div className="dispatch-page">
      <div className="page-header">
        <div>
          <h1>Despacho y Entregas</h1>
          <p>Gestiona las órdenes en tránsito</p>
        </div>
        <button className="btn-icon" onClick={fetchOrders} title="Actualizar">
          <HiOutlineRefresh />
        </button>
      </div>

      {/* Tabs */}
      <div className="dispatch-tabs">
        {Object.entries(STATUS_LABELS).map(([status, label]) => (
          <button
            key={status}
            className={`dispatch-tab ${tab === status ? 'active' : ''}`}
            style={tab === status ? { borderColor: STATUS_COLORS[status], color: STATUS_COLORS[status] } : {}}
            onClick={() => setTab(status)}
          >
            <span className="tab-count" style={{ background: STATUS_COLORS[status] }}>
              {counts[status]}
            </span>
            {label}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="loading-state"><div className="loader"></div><p>Cargando...</p></div>
      ) : filteredOrders.length === 0 ? (
        <div className="empty-state-card">
          <HiOutlineTruck className="empty-icon" />
          <p>No hay órdenes en este estado</p>
        </div>
      ) : (
        <div className="dispatch-list">
          {filteredOrders.map((order) => (
            <div key={order.id} className="dispatch-card">
              <div className="dispatch-info">
                <div className="dispatch-order">
                  <span className="dispatch-number">{order.order_number}</span>
                  <span className="dispatch-client">{order.client_name || `Cliente #${order.client_id}`}</span>
                </div>
                <div className="dispatch-meta">
                  <span>Vendedor: {order.salesman_name || '-'}</span>
                  <span className="dispatch-total mono">
                    RD$ {Number(order.total || 0).toLocaleString('es-DO', { minimumFractionDigits: 2 })}
                  </span>
                </div>
              </div>
              <div className="dispatch-action">
                {tab === 'prepared' && hasRole('delivery', 'admin') && (
                  <button
                    className="action-btn-dispatch"
                    style={{ background: '#f97316' }}
                    onClick={() => handleAction(order.id, orderService.dispatch, 'Despachada')}
                    disabled={actionLoading === order.id}
                  >
                    <HiOutlineTruck /> Despachar
                  </button>
                )}
                {tab === 'in_delivery' && hasRole('delivery', 'admin') && (
                  <button
                    className="action-btn-dispatch"
                    style={{ background: '#22c55e' }}
                    onClick={() => handleAction(order.id, orderService.deliver, 'Entregada')}
                    disabled={actionLoading === order.id}
                  >
                    <HiOutlineCheckCircle /> Entregar
                  </button>
                )}
                {tab === 'delivered' && (
                  <span className="delivered-badge">✓ Entregada</span>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Dispatch;
